import React from "react";
import { ButtonBase } from "@mui/material";
import { Box, styled } from "@mui/material";
import Typography from "@common/components/Typography";

export const Container = styled(Box)({});

export const Button = styled(ButtonBase)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  maxWidth: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
}));
export const IconContainer = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2),
  display: "flex",
  width: "1.5rem",
  height: "1.5rem",
}));
export const LabelContainer = styled(Box)({ maxWidth: "85%" });
export const StyledTypography = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: "1.5rem",
  textAlign: "left",
  wordBreak: "break-all",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
});

export const BorderlessCard = styled(Box)(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: theme.shape.borderRadius,
}));

export const BorderedCard = styled(BorderlessCard)(({ theme }) => ({
  border: `1px solid ${theme.palette.common.grey.gBFBFBF}`,
  borderRadius: theme.radius.small,
  "> *": {
    textDecoration: "none",
    color: "inherit",
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  width: "100%",
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
}));

export const StyledCard = ({
  ref,
  borderless = false,
  children,
  ...other
}: React.PropsWithChildren<{ borderless?: boolean }> & {
  ref?: React.Ref<HTMLDivElement>;
}) =>
  borderless ? (
    <BorderlessCard ref={ref} {...other}>
      {children}
    </BorderlessCard>
  ) : (
    <BorderedCard ref={ref} {...other}>
      {children}
    </BorderedCard>
  );
